{
  "required": "هذا الحقل مطلوب",
  "email": "البريد الإلكتروني غير صحيح",
  "minLength": "الحد الأدنى {{count}} حرف",
  "maxLength": "الحد الأقصى {{count}} حرف",
  "passwordWeak": "كلمة المرور ضعيفة",
  "passwordsMismatch": "كلمتا المرور غير متطابقتين",
  "invalidNumber": "أدخل قيمة رقمية",
  "positiveNumber": "أدخل قيمة أكبر من صفر",
  "invalidPhone": "أدخل رقم هاتف صحيح",
  "maxItems": "الحد الأقصى {{count}} عنصر"
}
